export enum SubscriptionTier{
    FREE = 'FREE',
    BASIC = 'BASIC',
    PREMIUM = 'PREMIUM',
    ENTERPRISE = "ENTERPRISE"
}